<template>
  <div>
    <v-list dense>
      <v-list-item v-for="(item, index) in slicedEmotions" :key="index">
        <v-list-item-content>
          <v-list-item-title class="d-flex justify-space-between mb-1">
            <div class="d-flex">
              {{ emotionEmojiMap[item.label] }}&nbsp;&nbsp;

              <div class="first-letter-uppercase">{{ item.label }}</div>
            </div>

            <span class="secondary--text">
              {{ fPercent(item.score * 100) }}
            </span>
          </v-list-item-title>

          <v-progress-linear :color="emotionColorMap[item.label]" :value="item.score * 100" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
// Import helper maps
import emotionEmojiMap from "@/helpers/emotionEmojiMap.js"
import emotionColorMap from "@/helpers/emotionColorMap.js"

// Export the SFC
export default {
  // Name of the component
  name: "EmotionsChart",

  // Accept incoming data from parent
  props: {
    emotions: {
      type: Array,
      required: true
    },

    count: {
      type: Number,
      required: false,
      default: 7
    }
  },

  // Define the data
  data() {
    return {
      emotionEmojiMap,
      emotionColorMap
    }
  },

  // Define computed properties
  computed: {
    /**
     * Slice the emotions array to only include the emotions
     *
     * @returns {Array}
     */
    slicedEmotions() {
      return this.emotions.filter((search) => search.label !== "neutral").slice(0, this.count)
    }
  }
}
</script>
